import { render, staticRenderFns } from "./DataTableSocialMedias.vue?vue&type=template&id=edecc8b0&scoped=true&"
import script from "./DataTableSocialMedias.vue?vue&type=script&lang=js&"
export * from "./DataTableSocialMedias.vue?vue&type=script&lang=js&"
import style0 from "./DataTableSocialMedias.vue?vue&type=style&index=0&id=edecc8b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edecc8b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDataTable,VIcon})
